module.exports = __webpack_public_path__ + "static/media/phone.2b23e08a.svg";